import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { INotificationTemplate } from '../../../models/NotificationTemplate';

import { AppService } from '../../../services/app.service';
import { NotificationTemplateService } from '../../../services/notification-template.service';

@Component({
    selector: 'app-notification-template-form',
    templateUrl: './notification-template-form.component.html'
})
export class NotificationTemplateFormComponent {
    constructor(
        private app: AppService,
        private service: NotificationTemplateService,
        private route: ActivatedRoute
    ) { }

    readonly canEdit = this.app.currentUser?.rights.includes('NOTIFICATION_TEMPLATE.EDIT');

    data: INotificationTemplate;
    error?: string;

    ngOnInit() {
        const id = this.route.snapshot.params['id'];

        if (!id) {
            this.data = <INotificationTemplate>{};
        } else {
            this.app.addLoading(this.service.getById(+id)).subscribe(data => {
                this.data = data;
            }, err => {
                this.error = this.app.getHttpResponseError(err);
            });
        }
    }
}
